module.exports = __webpack_public_path__ + "static/media/008tall.84ac92e2.jpg";